import { render, staticRenderFns } from "./ComplaintChannelManage.vue?vue&type=template&id=56097d98&"
import script from "./ComplaintChannelManage.vue?vue&type=script&lang=js&"
export * from "./ComplaintChannelManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports